import type { GenerationJobKind } from '../hooks/useGenerationJobs';

export const jobHistoryExpandedKey = (kind: GenerationJobKind) =>
  `generation_job_history_expanded:${kind}`;
